import React from 'react';
import { connect } from 'react-redux';

import {
  DIGITAL,
  EVENT,
  PHYSICAL,
  // SERVICE,
} from 'config/ProductTypes';

import {
  getOfferType,
  getDigitalOfferInfo,
  getEventOfferInfo,
  getPhysicalOfferInfo,
} from '../../reducers/ProductReducers';

const InfoBlock = ({
  type,
  digital: { fileType, fileSize },
  event: { startDate, endDate, venue },
  physical: { shipsWithin },
}) => {
  // DIGITAL is hardcoded as 'offer' in config/ProductTypes.js
  // so we have set the same in purchase_form_dialog.html
  if (type === DIGITAL) {
    return (
      <ul className="list-dotted soft--top flush--left">
        <li>{fileType}</li>
        <li>{fileSize}</li>
      </ul>
    );
  } else if (type === EVENT) {
    return (
      <ul className="list-dotted soft--top flush--left">
        <li><b>Start Date:</b> {startDate}</li>
        <li><b>End Date:</b> {endDate}</li>
        <li><b>Venue:</b> {venue}</li>
      </ul>
    );
  } else if (type === PHYSICAL) {
    return (
      <ul className="list-dotted soft--top flush--left">
        <li>{shipsWithin}</li>
      </ul>
    );
  } else {
    return null;
  }
};

const mapStateToProps = ({ product }) => ({
  type: getOfferType(product),
  digital: getDigitalOfferInfo(product),
  event: getEventOfferInfo(product),
  physical: getPhysicalOfferInfo(product),
});

export default connect(mapStateToProps)(InfoBlock);



// WEBPACK FOOTER //
// ./src/product/views/_layout/InfoBlock.js